module.exports = __webpack_public_path__ + "img/79.f139aa71.jpg";